import { render, staticRenderFns } from "./WallInfo.vue?vue&type=template&id=5c5446dc&scoped=true&"
import script from "./WallInfo.vue?vue&type=script&lang=js&"
export * from "./WallInfo.vue?vue&type=script&lang=js&"
import style0 from "./WallInfo.vue?vue&type=style&index=0&id=5c5446dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5446dc",
  null
  
)

export default component.exports